/**
 * @module app.bdc.list.formOrderTillsCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormOrderTillsCtrl($scope, $uibModalInstance, $log, nbTillsById, tills, tillsLimit, order, Notification) {
        var self = {};
        self.tills = tills.filter(till => {
            if(order.contract.scenarioType.code !== 'RENOUVELLEMENT'){
                return till.tillType.code !== 'FORFAIT';
            }
            if(order.contract.scenarioType.code === 'RENOUVELLEMENT'){
                return till.tillType.code !== 'PREMIUM_RECONDITIONNE';
            }
            return till;
        });

        self.tillsFilterRefurbished = function(till){
            return till.tillType.code.split('_').indexOf('RECONDITIONNE') > -1 && till.isAvailable;
        }

        self.tillsFilterNew = function(till){
            return till.tillType.code.split('_').indexOf('RECONDITIONNE') === -1 && till.isAvailable;
        }


        self.tillsLimit = tillsLimit;
        self.nbTillsById = nbTillsById;
        self.order = order;

        var _nbTills = self.tillsLimit.nbTills;

        /**
         * Increase the number of tills
         * @param  {Object} till
         */
        self.increaseNumberTill = function increaseNumberTill(till) {
            if (_nbTills === self.tillsLimit.limit) {
                return;
            }

            if(['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(till.tillType.code) > -1) {
                if(self.nbTillsById[till.id].nbTills + till.nbTills >= 3)
                     return;
                if(self.order.contract.contractType.code === 'LOC48' && self.order.contract.nbMonthsFidelity > 0){
                    if (till.tillType.code === 'PREMIUM_RECONDITIONNE') {
                        Notification.error('Vous ne pouvez ajouter de caisse reconditionnée sur un contrat en location 48 mois avec une offre de fidélité en cours.');
                        return
                    }
                }
            }
            if(self.order.isExceptionalOffer && _nbTills + till.nbTills > 3){
                Notification.error('L\'offre du mois est activée, vous ne pouvez ajouter plus de 3 caisses.');
                return;
            }

            self.nbTillsById[till.id].nbTills++;
            _nbTills++;
        };

        /**
         * Decrease the number of tills
         * @param  {Object} till
         */
        self.decreaseNumberTill = function decreaseNumberTill(till) {
            if (self.nbTillsById[till.id].nbTills === 0) {
                return;
            }

            self.nbTillsById[till.id].nbTills--;
            _nbTills--;
        };

        /**
         * Close the modal
         */
        self.ok = function ok() {
            $uibModalInstance.close();
        };

        /**
         * Cancel the modal
         */
        self.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    FormOrderTillsCtrl.$inject = [
        '$scope',
        '$uibModalInstance',
        '$log',
        'nbTillsById',
        'tills',
        'tillsLimit',
        'order',
        'Notification'
    ];

    angular
        .module('app.bdc.list.formOrderTillsCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('FormOrderTillsCtrl', FormOrderTillsCtrl);
});
